(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8819],{

/***/ 56189:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[productName]",
      function () {
        return __webpack_require__(56640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52177);
/* harmony import */ var utils_initializeUserContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22514);
/* harmony import */ var _yema_commerce_utils_error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38102);
/* harmony import */ var _yema_designkit_webkit_atoms_Loaders_LoaderLogo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82331);
/* harmony import */ var layouts_Page_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2952);
/* harmony import */ var layouts_NotFound_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51586);
/* harmony import */ var components_products_ProductPage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34724);
/* harmony import */ var _yema_commerce_components_checkout_Error500__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92308);













var ProductPageDetails = function(param) {
    var pageContent = param.pageContent, staticContent = param.staticContent, uspPromise = param.uspPromise, uspPromo = param.uspPromo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var authToken = (0,_yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v)(function(param) {
        var authentication = param.authentication;
        return authentication.token;
    });
    var dispatch = (0,_yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return (0,utils_initializeUserContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            authToken: authToken,
            dispatch: dispatch
        });
    }, [
        authToken,
        router.asPath
    ]);
    //@TODO Ludo: should show product page skeleton
    if (router.isFallback) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_atoms_Loaders_LoaderLogo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        position: "fixed",
        overlayColor: "rgba(253, 242, 241, .9)",
        withOverlay: true,
        active: true
    });
    if (pageContent && pageContent.error) {
        var ref;
        (0,_yema_commerce_utils_error__WEBPACK_IMPORTED_MODULE_10__/* .trackError */ .t)({
            label: "Fail to load product page",
            extras: {
                productSlug: router.query.productName,
                data: pageContent,
                error: pageContent.error
            }
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_commerce_components_checkout_Error500__WEBPACK_IMPORTED_MODULE_9__["default"], {
            title: "Error al cargar la p\xe1gina del producto",
            extrasToTrack: {
                errorType: "Fail to load product page",
                errorDescription: pageContent === null || pageContent === void 0 ? void 0 : (ref = pageContent.error) === null || ref === void 0 ? void 0 : ref.message
            },
            fullPage: true
        });
    }
    if (!pageContent || !pageContent.product) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_NotFound_layout__WEBPACK_IMPORTED_MODULE_7__["default"], {
        staticContent: staticContent
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_Page_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        staticContent: staticContent,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_products_ProductPage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, pageContent), {
            uspPromo: uspPromo,
            uspPromise: uspPromise
        }))
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductPageDetails);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9097,6577,4226,2952,4152,2723,9774,2888,179], function() { return __webpack_exec__(56189); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);